import { render } from "./dashboardPage.vue?vue&type=template&id=0c0fb6e4&scoped=true"
import script from "./dashboardPage.vue?vue&type=script&lang=js"
export * from "./dashboardPage.vue?vue&type=script&lang=js"

import "./dashboardPage.vue?vue&type=style&index=0&id=0c0fb6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0fb6e4"]])

export default __exports__